if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();

        // Conditional logging setup
        const isDev =
          window.location.hostname.includes('myshopify.com') ||
          window.location.hostname === 'localhost';
        // eslint-disable-next-line no-console
        this.log = isDev ? console.log.bind(console) : () => {};
        this.warn = isDev ? console.warn.bind(console) : () => {};
        this.error = isDev ? console.error.bind(console) : () => {};
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items, 10);
        this.tabletItems = parseInt(this.dataset.tabletItems, 10);

        this.sliderInstance = false;
        this.dependencyRetries = 0;
        this.maxDependencyRetries = 50; // Max 5 seconds of retries

        if (!this.enableSlider) return;

        // Wait for FoxTheme to be ready before initializing
        this.waitForDependencies();
      }

      waitForDependencies() {
        if (
          typeof window.FoxTheme !== 'undefined' &&
          window.FoxTheme.config &&
          window.FoxTheme.Swiper
        ) {
          this.mediaQueryList = window.matchMedia(FoxTheme.config.mediaQueryMobile);
          this.boundInit = this.init.bind(this);
          this.mediaQueryList.addEventListener('change', this.boundInit);
          this.init();
        } else {
          this.dependencyRetries++;
          if (this.dependencyRetries < this.maxDependencyRetries) {
            // Retry after a short delay if dependencies aren't ready
            setTimeout(() => this.waitForDependencies(), 100);
          } else {
            // Only warn in development environments
            this.warn(
              'FeaturedCollection: Dependencies (FoxTheme.config, FoxTheme.Swiper) not loaded after maximum retries'
            );
          }
        }
      }

      disconnectedCallback() {
        if (this.mediaQueryList && this.boundInit) {
          this.mediaQueryList.removeEventListener('change', this.boundInit);
          this.boundInit = null;
        }
        this.destroySlider();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window
          .getComputedStyle(this.sliderWrapper)
          .getPropertyValue('--column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
          slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems, 10),
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: false,
          breakpoints: {
            1280: {
              slidesPerView: parseInt(this.items, 10),
            },
          },
          loop: true,
          threshold: 2,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();

        this.calcNavButtonsPosition();
        this.calcHeadingColumnHeight();
        this.fixQuickviewDuplicate();
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object') return;

        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            '--swiper-navigation-top-offset',
            parseInt(firstMedia.clientHeight, 10) / 2 + 'px'
          );
        }
      }

      calcHeadingColumnHeight() {
        if (this.dataset.calcHeadingColumnHeight !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty('--heading-column-height', firstMedia.clientHeight + 'px');
        }
      }

      fixQuickviewDuplicate() {
        const modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
